(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("brandServices", BrandServicesService);

    BrandServicesService.$inject = ['$q', '$timeout', 'hUser'];

    function BrandServicesService($q, $timeout, hUser) {
        var self = this;
        let cachedBrandServices = {};

        let sharedState = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.SESSION,
            key: 'shared_state'
        });

        if (sharedState) {

            if (sharedState['services']) {
                for (const brandId in sharedState['services']) {
                    cachedBrandServices[brandId] = sharedState['services'][brandId]?.services;
                }
                delete sharedState['services'];
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.SESSION,
                    key: 'shared_state',
                    value: sharedState
                });
            }
        }

        var cachedBrandsAccessType = {};

        var ACTIVE_SERVICE = "ACTIVE";
        var PASS_SERVICE = "PASS";

        self.BRAND_ACCESS_TYPES = {
            ACTIVE: 'ACTIVE',
            PASS: 'PASS',
        };

        self.SERVICES = {
            'AVAILABLE_SHIFTS_EMAIL': 'AVAILABLE_SHIFTS_EMAIL',
            'SECOND_PHASE': 'SECOND_PHASE',
            'ON_BOARDING': 'ON_BOARDING',
            'GROUP_CAREER_PORTAL': 'GROUP_CAREER_PORTAL',
            'PAYROLL': 'PAYROLL',
            'ADAM': 'ADAM',
            'HARRI_AI_SUPPORT': 'HARRI_AI_SUPPORT',
            'DATA_PASS_SYNC': 'DATA_PASS_SYNC',
            'CUSTOM_REPORTS': 'CUSTOM_REPORTS',
            'JOB_DISTRIBUTOR': 'JOB_DISTRIBUTOR',
            'TEAM_SCHEDULING': 'TEAM_SCHEDULING',
            'TEAM': 'TEAM',
            'PRIVACY_SHIELD': 'PRIVACY_SHIELD',
            'AUTO_RESPONDER': 'AUTO_RESPONDER',
            'TTS_DASHBOARD': 'TTS_DASHBOARD',
            'UK_JOB_MESSAGE': 'UK_JOB_MESSAGE',
            'HIRING_RESTRICTION': 'HIRING_RESTRICTION',
            'ATS_BUCKET': 'ATS_BUCKET',
            'AI_SCREENING_CALLS': 'AI_SCREENING_CALLS',
            'JD_SECONDARY_PAYMENT': 'JD_SECONDARY_PAYMENT',
            'AUTO_LOAD_OFFER_TEMPLATE': 'AUTO_LOAD_OFFER_TEMPLATE',
            'CUSTOM_SWIMLANE': 'CUSTOM_SWIMLANE',
            'BLOCKED_PAST_EMPLOYEES': 'BLOCKED_PAST_EMPLOYEES',
            'RESUME_PREVIEW': 'RESUME_PREVIEW',
            'HARRI_CLOCK': 'HARRI_CLOCK',
            'DAILY_JOB_REPORT': 'DAILY_JOB_REPORT',
            'ATR': 'ATR',
            'AI_CANDIDATE_SUMMARIES': 'AI_CANDIDATE_SUMMARIES',
            'HIRING_RESTRICTION_NO_OFFER': 'HIRING_RESTRICTION_NO_OFFER',
            'RIGHT_TO_WORK': 'RIGHT_TO_WORK',
            'LIVE_WIRE_V2_DASHBOARD': 'LIVE_WIRE_V2_DASHBOARD',
            'E_VERIFY': 'E_VERIFY',
            'LPM_MOCK': 'LPM_MOCK',
            'PAYROLL_SYNC': 'PAYROLL_SYNC',
            'KEESING': 'KEESING',
            'TIPS_DISTRIBUTION': 'TIPS_DISTRIBUTION',
            'HARAF_RESTRICTION': 'HARAF_RESTRICTION',
            'ASSESSMENT': 'ASSESSMENT',
            'REASON_TO_SKIP': 'REASON_TO_SKIP',
            'REJECTION_TEMPLATES': 'REJECTION_TEMPLATES',
            'FORCED_JOB_TEMPLATE': 'FORCED_JOB_TEMPLATE',
            'AQAAF': 'AQAAF',
            'EMPLOYEE_POOL': 'EMPLOYEE_POOL',
            'INTERVIEW_V2': 'INTERVIEW_V2',
            'TCAF': 'TCAF',
            'PRIVATE_JOB_POST': 'PRIVATE_JOB_POST',
            'TENANT_JOBS': 'TENANT_JOBS',
            'ACTIVITY_BASED_SCHEDULING': 'ACTIVITY_BASED_SCHEDULING',
            'LOGJAM': 'LOGJAM',
            'INDEED_CAMPAIGN_MANAGEMENT': 'INDEED_CAMPAIGN_MANAGEMENT',
            'EARNED_WAGE_ACCESS': 'EARNED_WAGE_ACCESS',
            'GDPR': 'GDPR',
            'READY_TO_OFFER_COLUMN': 'READY_TO_OFFER_COLUMN',
            'QUESTION_BANK': 'QUESTION_BANK',
            'EEO_REPORT': 'EEO_REPORT',
            'EQUAL_EMPLOYMENT_OPPORTUNITY': 'EQUAL_EMPLOYMENT_OPPORTUNITY',
            'SSO_MCD': 'SSO_MCD',
            'RAW_DATA_REPORTING': 'RAW_DATA_REPORTING',
            'DOWNLOAD_CVS': 'DOWNLOAD_CVS',
            'PAR_LABOR': 'PAR_LABOR',
            'TRUST_ID_FULL': 'TRUST_ID_FULL',
            'TRUST_ID_LITE': 'TRUST_ID_LITE',
            'LMS': 'LMS',
            'UPSKILL': 'UPSKILL',
            'HARRI_ACADEMY': 'HARRI_ACADEMY',
            'DEMAND_FORECASTING': 'DEMAND_FORECASTING',
            'PREHIRE': 'PREHIRE',
            'POS': 'POS',
            'POS_ORACLE_SIMPHONY_SYNC': 'POS_ORACLE_SIMPHONY_SYNC',
            'POS_TOAST_SYNC': 'POS_TOAST_SYNC',
            'POS_JERSEY_MIKES_TICKET': 'POS_JERSEY_MIKES_TICKET',
            'POS_MERRITT': 'POS_MERRITT',
            'PROFILE_MATCHING': 'PROFILE_MATCHING',
            'POS_BRINK_SYNC': 'POS_BRINK_SYNC',
            'JOB_TITLE_SKILL_LEVEL': 'JOB_TITLE_SKILL_LEVEL',
            'GFE_INCIDENTS_TRACKING': 'GFE_INCIDENTS_TRACKING',
            'SOCIAL_REFERRAL': 'SOCIAL_REFERRAL',
            'VIDEO_INTERVIEW': 'VIDEO_INTERVIEW',
            'SCHEDULE_BUDGETING': 'SCHEDULE_BUDGETING',
            'BACKGROUND_CHECK': 'BACKGROUND_CHECK',
            'GP_CROSS_LOCATION': 'GP_CROSS_LOCATION',
            'WENDYS_LABOR_MODEL': 'WENDYS_LABOR_MODEL',
            'CARROL_LABOR_MODEL': 'CARROL_LABOR_MODEL',
            'MCD_LABOR_MODEL': 'MCD_LABOR_MODEL',
            'JACK_IN_THE_BOX_LABOR_MODEL': 'JACK_IN_THE_BOX_LABOR_MODEL',
            'MCD_BRAND_REPORTING': 'MCD_BRAND_REPORTING',
            'CLOCK_OUT_ATTESTATION_QUESTIONS': 'CLOCK_OUT_ATTESTATION_QUESTIONS',
            'GASTRONOMY_LABOR_MODEL': 'GASTRONOMY_LABOR_MODEL',
            'FAIR_SCHEDULING': 'FAIR_SCHEDULING',
            'MANAGE_EMAIL_CONTENT': 'MANAGE_EMAIL_CONTENT',
            'GLOBAL_TALENT_POOL': 'GLOBAL_TALENT_POOL',
            'CANDIDATE_PRIVACY': 'CANDIDATE_PRIVACY',
            'MICE': 'MICE',
            'EMPLOYEE_BENEFITS': 'EMPLOYEE_BENEFITS',
            'EMPLOYEE_SATISFACTION_MODEL': 'EMPLOYEE_SATISFACTION_MODEL',
            'LOGBOOK': 'LOGBOOK',
            'NEWS_FEED': 'NEWS_FEED',
            'WOTC': 'WOTC',
            'JOB_APPROVAL_FLOW': 'JOB_APPROVAL_FLOW',
            'HR_ACTIONS': 'HR_ACTIONS',
            'APPROVAL_FLOW': 'APPROVAL_FLOW',
            'CARRI_RAPID_RESPONSE': 'CARRI_RAPID_RESPONSE',
            'TEAM_QUESTIONING': 'TEAM_QUESTIONING',
            'APPRENTICE_JOBS': 'APPRENTICE_JOBS',
            'ONBOARDING_DOCS_PRESELECTION': 'ONBOARDING_DOCS_PRESELECTION',
            'CUSTOM_DASHBOARD': 'CUSTOM_DASHBOARD',
            'PERFORMANCE_REVIEW': 'PERFORMANCE_REVIEW',
            'ENTERPRISE_COMMUNICATION': 'ENTERPRISE_COMMUNICATION',
            'COMPAAS_DASHBOARD': 'COMPAAS_DASHBOARD',
            'VOLUNTARY_STANDBY_LIST': 'VOLUNTARY_STANDBY_LIST',
            'RECURRING_PAY_ADJUSTMENTS': 'RECURRING_PAY_ADJUSTMENTS',
            'ACCOUNT_SUSPENDED':'ACCOUNT_SUSPENDED',
            'APPLICANT_AUTO_IMPORT':'APPLICANT_AUTO_IMPORT',
            'APPLICANT_AUTO_IMPORT_MYSTUFF2':'APPLICANT_AUTO_IMPORT_MYSTUFF2',
            'TEAM_AUTO_IMPORT':'TEAM_AUTO_IMPORT',
            'CARRI_CHATBOT':'CARRI_CHATBOT',
            'NYC_JUST_CAUSE':'NYC_JUST_CAUSE',
            'ANALYTICS_BARRI':'ANALYTICS_BARRI',
            'CUSTOM_FORM_BUILDER':'CUSTOM_FORM_BUILDER',
            'WAGE_MATRIX': 'WAGE_MATRIX',
            'PENSION_MATRIX': 'PENSION_MATRIX',
            'MFA': 'MFA',
            'RISK_DETECTION': 'RISK_DETECTION',
            'EMPLOYEE_NOTES': 'EMPLOYEE_NOTES',
            'MINOR_HANDLING': 'MINOR_HANDLING',
            'LOA': 'LOA',
            'ABSENCE_MANAGEMENT': 'ABSENCE_MANAGEMENT',
            'TIPS_MANAGEMENT': 'TIPS_MANAGEMENT',
            'PRIMARY_POSITION': 'PRIMARY_POSITION',
            'SALES_FORECAST_FEED': 'SALES_FORECAST_FEED',
            'POS_QU_SYNC': 'POS_QU_SYNC',
            'ANONYMISING_EMPLOYEES': 'ANONYMISING_EMPLOYEES',
            'CORE_HR_UPDATES_INTEGRATION': 'CORE_HR_UPDATES_INTEGRATION',
            'CUSTOM_REPORTING_HIERARCHY': 'CUSTOM_REPORTING_HIERARCHY',
            'HARRI_ENGAGE': 'HARRI_ENGAGE',
            'ONBOARDING_JOURNEY': 'ONBOARDING_JOURNEY',
            'EMPLOYMENT_TYPES': 'EMPLOYMENT_TYPES',
            'NI_AUTO_ASSIGN': 'NI_AUTO_ASSIGN',
            'IPC_INTEGRATION': 'IPC_INTEGRATION',
            'MEAL_PLAN_PARTICIPANT': 'MEAL_PLAN_PARTICIPANT',
            'AUTOMATED_ONBOARDING': 'AUTOMATED_ONBOARDING',
            'CORE_HR': 'CORE_HR',
            'EMPLOYEE_WORK_RESTRICTION': 'EMPLOYEE_WORK_RESTRICTION',
            'SCHEDULE_REPORTS': 'SCHEDULE_REPORTS',
            'HALO_DASHBOARD': 'HALO_DASHBOARD',
            'BUSINESS_POSITIONS_HIERARCHY': 'BUSINESS_POSITIONS_HIERARCHY',
            'WORKING_PATTERNS': 'WORKING_PATTERNS',
            'WORK_LIMIT': 'WORK_LIMIT',
            'REWARDS_AND_RECOGNITION': 'REWARDS_AND_RECOGNITION',
        };

        var servicesBuffer = new hBuffer($q);

        servicesBuffer
            .filterIds(function (brandIds) {
                var filtered = [];

                for (var i in brandIds) {
                    if (!cachedBrandServices[brandIds[i]]) {
                        filtered.push(brandIds[i]);
                    }
                }

                return filtered;
            })
            .doAsync(function (brandIds) {
                var defer = $q.defer();

                BrandAPI.getBrandServicesAsObjects(brandIds)
                    .then(function (res) {
                        defer.resolve(res);
                    }, function (err) {
                        console.error(err);
                        defer.reject(err);
                    });

                return defer.promise;
            })
            .processResult(function (brandAccessData) {

                for (var brandId in brandAccessData) {
                    cachedBrandServices[brandId] = brandAccessData[brandId].services[brandId];
                    cachedBrandsAccessType[brandId] = brandAccessData[brandId].access_type;
                }

                return brandAccessData;
            });

        var checkService = function (brandId, serviceCode, includePASS) {

            var services = cachedBrandServices[brandId];
            includePASS = includePASS || false;

            if (services && services.length) {
                for (var i = 0; i < services.length; i++) {
                    var service = services[i],
                        checkType = (service.type === ACTIVE_SERVICE || includePASS && service.type === PASS_SERVICE);
                    if (checkType && serviceCode === service.code) {
                        return true;
                    }
                }
            } else {
                console.warn("cachedBrandServices is empty for:", brandId);
            }

            return false;
        };

        self.getServices = function (brandId, includePASS) {
            var defer = $q.defer();

            servicesBuffer.register(parseInt(brandId))
                .then(function () {
                    var services = cachedBrandServices[brandId] || [];
                    var result = [];

                    for (var i in services) {
                        if (checkService(brandId, services[i].code, includePASS)) {
                            result.push(services[i].code);
                        }
                    }

                    defer.resolve(result);
                });

            return defer.promise;
        };

        self.checkAll = function (brandId, serviceCodes, includePASS) {
            var promises = {};

            for (var i = 0; i < serviceCodes.length; i++) {
                if (serviceCodes[i]) {
                    promises[serviceCodes[i]] = self.check(serviceCodes[i], brandId, includePASS);
                }
            }

            return $q.all(promises);
        };

        self.checkOnAnyBrand = function (serviceCode) {
            if (hUser.isTopLevelContext()) {
                throw "You can't check service on any brand in HMAP mode";
            }

            return check(serviceCode);
        };

        self.check = function (serviceCode, brandId, includePASS) {
            if (!brandId) {
                throw "Brand id is required, got: " + brandId;
            }

            return check(serviceCode, brandId, includePASS);
        };

        var check = function (serviceCode, brandId, includePASS) {

            if (!serviceCode) {
                throw "Service code is required, got: " + serviceCode;
            }

            includePASS = includePASS || false;

            var defer = $q.defer();

            var user = hUser.data.user;
            var _onDoneCB;

            var result = defer.promise;

            result['value'] = undefined;
            result['ready'] = false;
            result['passIncluded'] = !!includePASS;
            result['getValue'] = function (cb) {
                if (result.ready) {
                    $timeout(function () {
                        cb(result.value);
                    });
                } else {
                    _onDoneCB = cb;
                }
            };

            if (hUser.isEmployer()) {
                if (!brandId) {
                    result.value = user.services.indexOf(serviceCode) > -1;
                    result.ready = true;

                    if (_onDoneCB) {
                        $timeout(function () {
                            _onDoneCB(result.value);
                        });
                    }

                    defer.resolve(result.value);

                } else {
                    servicesBuffer.register(parseInt(brandId))
                        .then(function () {
                            result.value = checkService(brandId, serviceCode, includePASS);
                            result.ready = true;

                            if (_onDoneCB) {
                                $timeout(function () {
                                    _onDoneCB(result.value);
                                });
                            }

                            defer.resolve(result.value);
                        });
                }
            } else {
                defer.resolve(false);
            }

            return result;
        };

        self.getBrandAccessType = function (brandId) {
            var defer = $q.defer();

            if (cachedBrandsAccessType[brandId]) {
                defer.resolve(cachedBrandsAccessType[brandId])
            } else {
                servicesBuffer.register(parseInt(brandId))
                    .then(() => {
                        defer.resolve(cachedBrandsAccessType[brandId]);
                    })
                    .catch((err) => console.error(err));
            }

            return defer.promise;
        };
    }
})();
